<template>
    <modal v-if="showModal">
        <div slot="header">
            <h2>Share this Pimblr Post</h2>
        </div>
        <div slot="footer">
            <button class="btn btn-primary" @click.prevent="closeShareModal()">Close</button>
        </div>
        <div slot="body" class="text-center">
            <a href="#" @click.prevent="shareTumblr" @mouseover="hover='tumblr'" class="shareBtn tumblr"><icon icon="tumblr-square" collection="fab" size="4x"/></a>
            <a href="#" @click.prevent="shareFacebook" @mouseover="hover='facebook'" class="shareBtn facebook"><icon icon="facebook-square" collection="fab" size="4x"/></a>
            <a href="#" @click.prevent="shareTwitter" @mouseover="hover='twitter'" class="shareBtn twitter"><icon icon="twitter-square" collection="fab" size="4x"/></a>
            <a href="#" @click.prevent="sharePinterest" @mouseover="hover='pinterest'" class="shareBtn pinterest"><icon icon="pinterest-square" collection="fab" size="4x"/></a>

            <div class="form-group-sm mt-2">
                <label class="col-form-label-sm">Post URL:</label>
                <input class="form-control form-control-sm" :value="getPostUrl()"/>
            </div>

            <hr>

            <div class="share-img-container">
                <div :style="{'background-image':imgPreview}"></div>
                <transition name="fade">
                    <div v-show="showBlurred" :style="{'background-image':imgBlurred}"></div>
                </transition>

            </div>
            <h5 class="mt-2">{{post.post.title}}</h5>

        </div>
    </modal>
</template>

<script>

    import Icon from "../ui/Icon";
    import Modal from "../ui/Modal";

    export default {
        name: "share-modal",
        data(){
            return {
                post: null,
                showModal: false,
                hover: 'tumblr'
            }
        },
        computed: {
            imgPreview(){
                 return "url('"+this.post.post.preview+"')";
            },
            imgBlurred(){
                return "url('"+this.blurredPreview+"')";
            },
            blurredPreview(){
                return document.location.protocol+'//'+document.location.host+'/api/v1/posts/preview/'+this.post.post._id+'/blurred.jpg';
            },
            showPreview(){
                return (this.post && this.hover==='tumblr')
            },
            showBlurred(){
                return (this.post && this.hover!=='tumblr')
            },
        },
        created(){
            this.$bus.$on('openShareModal', (data)=>{
                this.post = data.post;
                this.showModal = true;
                this.$bus.$emit('modal.open', 'shareModal');
                this.$bus.$emit('track.event', {name:'ShareDialog.open', data: this.post.post._id})
            });
            this.$bus.$on('closeModal', (data)=>{
                this.closeShareModal();
            });
        },
        methods: {
            closeShareModal(){
                this.$bus.$emit('modal.close', 'shareModal');
                this.showModal = false;
            },
            getPostUrl(){
                let route = this.$router.resolve({name:'BlogPageVideo', params:{blogUrl:this.post.blog.url, videoId:this.post._id}})
                let url   = document.location.protocol+'//'+document.location.host+route.location.path;
                return url;
            },
            getTitle(){
                return 'Check out this hot video at: ';
            },
            shareTumblr(){
                let title   = encodeURIComponent(this.getTitle() + this.getPostUrl());
                let postUrl = encodeURIComponent(this.getPostUrl());
                let imgUrl  = encodeURIComponent(this.post.post.preview);
                let shareUrl = `http://www.tumblr.com/share/photo?source=${imgUrl}&caption=${title}&canonicalUrl=${postUrl}`;
                this.$bus.$emit('track.event', {name:'ShareDialog.exec', data: 'Tumblr: ' + this.post.post._id});
                window.open(shareUrl, 'tumblrShare', 'width=540,height=600');
            },
            shareFacebook(){
                let title    = encodeURIComponent(this.getTitle());
                let postUrl  = encodeURIComponent(this.getPostUrl());
                let imgUrl  = encodeURIComponent(this.blurredPreview);
                let shareUrl = `http://www.facebook.com/sharer.php?u=${postUrl}`;
                this.$bus.$emit('track.event', {name:'ShareDialog.exec', data: 'Facebook: ' + this.post.post._id});
                window.open(shareUrl, 'facebookShare', 'width=540,height=600');
            },
            shareTwitter(){
                let title    = encodeURIComponent(this.getTitle());
                let postUrl  = encodeURIComponent(this.getPostUrl());
                let imageUrl = encodeURIComponent(this.blurredPreview);
                let shareUrl = `https://twitter.com/intent/tweet?url=${postUrl}`;
                this.$bus.$emit('track.event', {name:'ShareDialog.exec', data: 'Twitter: ' + this.post.post._id});
                window.open(shareUrl, 'twitterShare', 'width=540,height=600');
            },
            sharePinterest(){
                let title    = encodeURIComponent(this.getTitle());
                let imageUrl = encodeURIComponent(this.blurredPreview);
                let postUrl  = encodeURIComponent(this.getPostUrl());
                let shareUrl = `http://pinterest.com/pin/create/button/?url=${postUrl}&media=${imageUrl}&description=${title}`
                this.$bus.$emit('track.event', {name:'ShareDialog.exec', data: 'Pinterest: ' + this.post.post._id});
                window.open(shareUrl, 'pinterestShare', 'width=540,height=600');
            }
            // ToDo: Add Instagram?
        },
        components: {
            Icon,
            Modal
        }
    }
</script>

<style lang="sass" scoped>


    .col-form-label-sm
        margin-bottom: 0

    .shareBtn
        display: inline-block
        margin: 0 5px
        transition: .2s opacity ease-in-out

        &:hover
            opacity: .7

    .tumblr .fa-icon
        color: #36465d

    .facebook .fa-icon
        color: #29487d

    .twitter .fa-icon
        color: #1da1f2

    .pinterest .fa-icon
        color: rgb(189, 8, 28)


    .fade-enter-active, .fade-leave-active
        transition: opacity .25s ease-out

    .fade-enter, .fade-leave-to
        opacity: 0

    .share-img-container
        position: relative
        height: 300px

        div
            position: absolute
            top: 0
            left: 0
            width: 100%
            height: 300px
            background-size: contain
            background-repeat: no-repeat
            background-position: 50% 50%


</style>



// WEBPACK FOOTER //
// src/components/layout/ShareModal.vue